import NextChapter from "./assets/nextChapter.png";
import ProjectOasisLogo from "./assets/Oasis_Logo_1.2(scaled).png";
import cakois from "./assets/optimized/cakois.jpg";
import cgiq from "./assets/optimized/cgiq.jpg";
import dosm from "./assets/optimized/dosm.jpg";
import emar_markets from "./assets/optimized/emar_markets.jpg";
import goldsandsErp from "./assets/optimized/goldsands_erp.jpg";
import goldsandsHotel from "./assets/optimized/goldsands_hotel.jpg";
import iqi_erp from "./assets/optimized/iqi_erp.jpg";
import prop_mall from "./assets/optimized/prop_mall.jpg";
import web_finance_management from "./assets/optimized/web_finance_management.jpg";
import parcelManagement from "./assets/parcelManagement.png";
import profile_img from "./assets/profile.jpeg";
import rebelPoker from "./assets/rebelPoker.png";

export const enum_data = {
  profile_img: profile_img,
  about:
    "A software developer with extensive experience in full-stack web and mobile application development. Specialised in React, React Native (Expo), and NestJS, with strong analytical, communication, and AI prompting skills to deliver efficient, scalable solutions and collaborate effectively within teams.",
  experience: [
    { value: "7+", label: "Years of Experience" },
    { value: "23+", label: "Projects Completed" },
    { value: "20+", label: "Technologies Mastered" },
  ],
  contact_information: [
    {
      icon: "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2a9 9 0 0 0-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z",
      title: "Phone",
      content: "+60 18-6652481",
      action: {
        href: "tel:+60186652481",
        text: "Call Now",
      },
    },
    {
      icon: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
      title: "Email",
      content: "zaiman670@gmail.com",
      action: {
        href: "mailto:zaiman670@gmail.com",
        text: "Email Me",
      },
    },
    {
      icon: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z",
      title: "Location",
      content: "Kajang, Selangor, Malaysia",
      action: {
        href: "https://maps.google.com",
        text: "View on Map",
        icon: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
        isExternal: true,
      },
    },
  ],
  social_links: [
    {
      href: "https://github.com/zaimanza",
      label: "GitHub",
      icon: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z",
    },
    {
      href: "https://www.linkedin.com/in/zul-aiman-029aba202/",
      label: "LinkedIn",
      icon: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z",
    },
    {
      href: "mailto:zaiman670@gmail.com",
      label: "Email",
      icon: "M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z",
    },
  ],
  what_i_do: [
    {
      icon: "M24 10.935v2.131l-8 3.947v-2.23l5.64-2.783-5.64-2.79v-2.223l8 3.948zm-16 3.848l-5.64-2.783 5.64-2.79v-2.223l-8 3.948v2.131l8 3.947v-2.23zm7.047-10.783h-2.078l-4.011 16h2.073l4.016-16z",
      title: "AI Prompt Development",
      description:
        "Using Next-Gen Codex to develop full scalable software solutions with AI assistance, including code generation, debugging, and optimization.",
    },
    {
      icon: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 16.057v-3.057h2.994c-.059 1.143-.212 2.24-.456 3.279-.823-.12-1.674-.188-2.538-.222zm1.957 2.162c-.499 1.33-1.159 2.497-1.957 3.456v-3.62c.666.028 1.319.081 1.957.164zm-1.957-7.219v-3.015c.868-.034 1.721-.103 2.548-.224.238 1.027.389 2.111.446 3.239h-2.994zm0-5.014v-3.661c.806.969 1.471 2.15 1.971 3.496-.642.084-1.3.137-1.971.165zm2.703-3.267c1.237.496 2.354 1.228 3.29 2.146-.642.234-1.311.442-2.019.607-.344-.992-.775-1.91-1.271-2.753zm-7.241 13.56c-.244-1.039-.398-2.136-.456-3.279h2.994v3.057c-.865.034-1.714.102-2.538.222zm2.538 1.776v3.62c-.798-.959-1.458-2.126-1.957-3.456.638-.083 1.291-.136 1.957-.164zm-2.994-7.055c.057-1.128.207-2.212.446-3.239.827.121 1.68.19 2.548.224v3.015h-2.994zm1.024-5.179c.5-1.346 1.165-2.527 1.97-3.496v3.661c-.671-.028-1.329-.081-1.97-.165zm-2.005-.35c-.708-.165-1.377-.373-2.018-.607.937-.918 2.053-1.65 3.29-2.146-.496.844-.927 1.762-1.272 2.753zm-.549 1.918c-.264 1.151-.434 2.36-.492 3.611h-3.933c.165-1.658.739-3.197 1.617-4.518.88.361 1.816.67 2.808.907zm.009 9.262c-.988.236-1.92.542-2.797.9-.89-1.328-1.471-2.879-1.637-4.551h3.934c.058 1.265.231 2.488.5 3.651zm.553 1.917c.342.976.768 1.881 1.257 2.712-1.223-.49-2.326-1.211-3.256-2.115.636-.229 1.299-.435 1.999-.597zm9.924 0c.7.163 1.362.367 1.999.597-.931.903-2.034 1.625-3.257 2.116.489-.832.915-1.737 1.258-2.713zm.553-1.917c.27-1.163.442-2.386.501-3.651h3.934c-.167 1.672-.748 3.223-1.638 4.551-.877-.358-1.81-.664-2.797-.9zm.501-5.651c-.058-1.251-.229-2.46-.492-3.611.992-.237 1.929-.546 2.809-.907.877 1.321 1.451 2.86 1.616 4.518h-3.933z",
      title: "ERP Web Development",
      description:
        "Building responsive, fast, and accessible websites using modern frameworks like React, Vue, and Angular.",
    },
    {
      icon: "M18.5 0h-14c-1.1 0-2 .9-2 2v20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-20c0-1.1-.9-2-2-2zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4h-15v-16h15v16z",
      title: "Mobile Development (IOS/Android)",
      description:
        "Creating cross-platform mobile applications with Flutter and React Native for iOS and Android.",
    },
    {
      icon: "M24 10.935v2.131l-8 3.947v-2.23l5.64-2.783-5.64-2.79v-2.223l8 3.948zm-16 3.848l-5.64-2.783 5.64-2.79v-2.223l-8 3.948v2.131l8 3.947v-2.23zm7.047-10.783h-2.078l-4.011 16h2.073l4.016-16z",
      title: "Backend Development",
      description:
        "Building robust server-side applications with Node.js, Express, NestJs and other backend technologies.",
    },
    {
      icon: "M24 10.935v2.131l-8 3.947v-2.23l5.64-2.783-5.64-2.79v-2.223l8 3.948zm-16 3.848l-5.64-2.783 5.64-2.79v-2.223l-8 3.948v2.131l8 3.947v-2.23zm7.047-10.783h-2.078l-4.011 16h2.073l4.016-16z",
      title: "UI/UX Design",
      description:
        "Creating intuitive and engaging user experiences that delight your users and meet business goals.",
    },
  ],
  projects: [
    {
      image: ProjectOasisLogo,
      imageWidth: 250,
      imageHeight: 208,
      title: "Project Oasis",
      description:
        "A virtual ecosphere where you can gather to play games, socialize, and perform DeFi activities in-game such as staking crypto tokens, NFT minting, participating in IDOs, and more. Our dream is to build a place where everyone can come together to interact, play, compete and grow with one another.",
      technologies: ["BigchainDB", "ExpressJS", "MongoDB"],
      demo: "https://www.coingecko.com/en/coins/projectoasis",
      contributions: [
        "Developed backend services and APIs for mini-games within the Oasis Metaverse.",
        "Developed leaderboard queries to track, rank, and display player performance across games in the Oasis Metaverse.",
      ],
    },

    {
      image: NextChapter,
      imageWidth: 1190,
      imageHeight: 921,
      title: "Next Chapter",
      description: "Wedding invitation card.",
      technologies: ["React", "Tailwind CSS"],
      code: "https://github.com/zaimanza/next-chapter-fe",
      contributions: [
        "Developed a wedding invitation card customisation feature that allows users to personalise card designs, content, and messages.",
        "Implemented an RSVP management feature that enables guests to respond to invitations and allows users to track attendance efficiently.",
      ],
    },
    {
      image: rebelPoker,
      imageWidth: 716,
      imageHeight: 409,
      title: "Rebel Poker",
      description: "NFT website for Rebel Poker Collection.",
      technologies: ["React", "Tailwind CSS", "Framer Motion"],
      demo: "https://rebelpoker.co.za/",
      contributions: [
        "Developed an interactive, animated landing website for the Rebel Poker NFT website using Framer Motion, enhancing visual appeal and user engagement.",
        "Implemented a fully responsive design to ensure a consistent and optimised user experience across different devices and screen sizes.",
      ],
    },
    {
      image: parcelManagement,
      imageWidth: 615,
      imageHeight: 1274,
      title: "Kedai Siswa Parcel Management",
      description: "Parcel Management Application for Kedai Siswa in Dungun.",
      technologies: ["Flutter", "MongoDB", "GraphQL"],
      code: "https://github.com/zaimanza/parcel_management_flutter",
      contributions: [
        "Developed a full-stack parcel management application for Kedai Siswa at UiTM Dungun, streamlining parcel delivery and collection processes while improving operational efficiency.",
      ],
    },
    {
      image: iqi_erp,
      imageWidth: 1800,
      imageHeight: 1045,
      title: "IQI Global ERP",
      description:
        "ERP used to automate business operation including finance, admins and reporting.",
      technologies: ["React", "SCSS", "Bootstrap"],
      demo: "https://erp.iqiglobal.com/",
      contributions: [
        "Revamped the existing ERP codebase to version 2.0 by upgrading React, restructuring reusable components, improving page-load performance, and enhancing the overall user experience.",
        "Developed a binary tree module to visualise the hierarchical structure of IQI agents and their downlines, enabling more effective network management.",
        "Revamped the Subsales module for managing property resale and rental transactions, including invoice and contract generation, agent commission calculations, and transaction status tracking.",
        "Developed a dynamic banner module that enables agents to automatically generate printable marketing materials.",
        "Integrated a built-in Canva design editor within the Agent Atlas website, allowing agents to create and customise their own marketing designs.",
        "Implemented multilingual support across the ERP system to improve accessibility for users in different regions.",
        "Developed country-specific versions of the IQI ERP system for markets including the Philippines and Canada.",
      ],
    },
    {
      image: prop_mall,
      imageWidth: 1800,
      imageHeight: 1012,
      title: "PropMall",
      description:
        "PropMall.co is a digital property marketplace that connects property buyers, sellers, and real estate agents through a platform.",
      technologies: ["React", "SCSS", "Tailwind CSS", "Bootstrap"],
      demo: "https://www.propmall.co/login",
      contribution: [
        "Revamped the Prop Mall Cambodia website to improve its visual design, responsiveness, and overall user experience.",
        "Developed a property filtering feature that allows users to efficiently search and refine property listings based on selected criteria.",
      ],
    },
    {
      image: dosm,
      imageWidth: 1800,
      imageHeight: 1556,
      title: "NEWSS Jabatan Perangkaan Malaysia (DOSM)",
      description:
        "National Enterprise-Wide Statistical Systems (NEWSS 2.0) ERP system used to store all businesses and other data used by the government of Malaysia.",
      technologies: ["React", "Bootstrap", "Jenkins", "Docker", "AWS"],
      demo: "https://newss.dosm.gov.my/",
      contribution: [
        "Standardised reusable UI components across multiple modules within the NEWSS ERP system.",
        "Developed the Rangka Pentadbiran module based on defined business and functional requirements.",
        "Maintained, enhanced, and revamped existing modules to improve code quality, usability, and overall performance.",
        "Collaborated closely with backend developers and business analysts to ensure accurate implementation of system requirements.",
      ],
    },
    {
      image: web_finance_management,
      imageWidth: 1800,
      imageHeight: 1095,
      title: "Financial Management System",
      description:
        "A personal financial management system used to manage accounts, transactions, budgeting, internal transfer, credit, loans, reporting and general ledgers. This system is developeed for Web, Mac and Windows platform.",
      technologies: [
        "NextJs",
        "SCSS",
        "Tailwind CSS",
        "Bootstrap",
        "SQLite",
        "ElectronJs",
      ],
      demo: "https://web-financial-management.vercel.app/login",
      contribution: [
        "Developed a complete full-stack financial management system designed for local deployment.",
        "Implemented SQLite to provide a lightweight, independent, and locally stored financial database.",
        "Converted the web-based system into a cross-platform desktop application for macOS and Windows.",
        "Developed reporting modules for General Ledgers, Ledgers, Accounts, Allocations, External Wallets, and Counterparties.",
        "Implemented multi-user functionality to support multiple users within a single financial system.",
        "Developed a secure authentication and authorisation system for managing user access.",
        "Built database management features for importing, exporting, backing up, and restoring the entire system database.",
        "Implemented XLSX export functionality for downloading and managing financial reports.",
      ],
    },
    {
      image: emar_markets,
      imageWidth: 1800,
      imageHeight: 994,
      title: "Emar Markets Trading Platform",
      description:
        "A trading platform for Emar Markets, a financial services company that provides online trading services for forex, commodities, indices, and cryptocurrencies.",
      technologies: ["ReactJs", "SCSS", "Tailwind CSS", "Bootstrap"],
      demo: "https://www.emarmarkets.com/ms",
      contribution: [
        "Developed a custom trading platform website based on the FXBO template and integrated it with the provided APIs.",
        "Built a backend service to process FXBO API requests and transform the returned data into a structure compatible with the Emar Markets trading platform.",
        "Developed a responsive, mobile-first frontend that allows users to securely log in and manage their trading wallets.",
      ],
    },
    {
      image: cgiq,
      imageWidth: 1800,
      imageHeight: 934,
      title: "Cerdas Genius IQ Tuition Centre",
      description:
        "A tuition centre website for Cerdas Genius IQ, a tuition centre that provides online and offline classes for students in Malaysia.",
      technologies: ["ReactJs", "SCSS", "Tailwind CSS", "Bootstrap"],
      demo: "https://cerdasgeniusiq.com/",
      contribution: [
        "Developed a corporate landing website for CGIQ to showcase the company's services and help parents better understand its educational offerings. Integrated SMTP email functionality and Google Forms to manage registrations and enquiries.",
      ],
    },
    {
      image: cakois,
      imageWidth: 1800,
      imageHeight: 1098,
      title: "Cakoi's Website",
      description:
        "A website for Cakoi's, a local food business that sells traditional Malaysian snacks and desserts.",
      technologies: ["NextJs", "SCSS", "Tailwind CSS", "Bootstrap"],
      demo: "https://v0-cakoi-website-design.vercel.app/",
      contribution: [
        "Developed an interactive, cartoon-inspired website with engaging animations, tailored to a young audience for promoting and selling cakoi.",
      ],
    },
    {
      image: goldsandsHotel,
      imageWidth: 1800,
      imageHeight: 1042,
      title: "Goldsands Hotel Langkawi",
      description:
        "A guest-facing hotel website for Goldsands Hotel Langkawi, helping travellers explore rooms, compare nightly rates, and discover local experiences.",
      technologies: ["Next.js", "React", "CSS", "Lucide Icons"],
      demo: "https://goldsands-hotel-test.netlify.app/",
      contribution: [
        "Built the hotel website with room listings, featured stays, and room photography to help guests find their ideal accommodation.",
        "Developed a stay search interface with check-in and check-out date selection and guest filters, alongside room favourites and experience browsing.",
      ],
    },
    {
      image: goldsandsErp,
      imageWidth: 1800,
      imageHeight: 1042,
      title: "Goldsands Hotel Langkawi ERP",
      description:
        "A hotel management ERP for Goldsands Hotel Langkawi, centralising bookings, property information, and administrative workflows in one dashboard.",
      technologies: ["Next.js", "React", "CSS", "Lucide Icons"],
      demo: "https://goldsands-hotel-erp-test.netlify.app/",
      contribution: [
        "Built an operations dashboard displaying room types, total bookings, pending cancellation requests, and confirmed revenue for a clear overview of hotel activity.",
        "Developed management interfaces for bookings, cancellation requests, rooms, room categories, amenities, experiences, house rules, and administrator accounts.",
      ],
    },
  ],
  skills: [
    {
      label: "Programming Languages",
      skills: ["JavaScript", "TypeScript", "SQL"],
    },
    {
      label: "Frontend & Mobile",
      skills: [
        "React.js",
        "Next.js",
        "React Native",
        "Vue.js",
        "Angular",
        "Flutter",
      ],
    },
    {
      label: "Backend & APIs",
      skills: ["Node.js", "Express", "NestJS", "GraphQL"],
    },
    {
      label: "Web Styling",
      skills: ["HTML", "CSS", "SCSS", "Bootstrap", "Tailwind CSS"],
    },
    {
      label: "Databases & Data",
      skills: ["MongoDB", "PostgreSQL", "SQL", "Firebase", "SQLite"],
    },
    {
      label: "DevOps & Tools",
      skills: ["Jenkins", "Docker", "AWS", "Git", "Electron.js"],
    },
    {
      label: "Design",
      skills: ["Figma"],
    },
  ],
  work_experience: [
    {
      name: "Frontend Developer (Intern Diploma)",
      role: "SV Partners Sdn. Bhd.",
      date: "Jun 2019 - Nov 2019",
    },
    {
      name: "Backend Developer (Contract)",
      role: "Hirodeli Enterprise",
      date: "May 2020 - Mar 2021",
    },
    {
      name: "Fullstack Maintenance Developer (Contract)",
      role: "Krenovator",
      date: "Oct 2021 - Nov 2021",
    },
    {
      name: "Database/Backend Developer (Intern Degree)",
      role: "Digital Cultivation",
      date: "Mar 2022 - Aug 2022",
    },
    {
      name: "Frontend Developer (Permanent)",
      role: "IQI Global Sdn. Bhd.",
      date: "Sep 2022 - Aug 2025",
    },
    {
      name: "Lead Developer (Contract)",
      role: "Horuz Markets",
      date: "May 2023",
    },
    {
      name: "Frontend Developer (Contract)",
      role: "Innovatz Solution Sdn. Bhd. | Silverlake Innovation Partners Sdn. Bhd.",
      date: "Nov 2025 - Present",
    },
  ],
  education: [
    {
      degree: "Diploma, Computer Science",
      institution: "University Technology MARA (Segamat)",
      years: "2017 - 2019",
      cgpa: "3.45",
    },
    {
      degree: "Bachelor's Degree, Information System Engineering",
      institution: "University Technology MARA (Shah Alam)",
      years: "2020 - 2022",
      cgpa: "3.23",
    },
  ],
  language: [
    { language: "English", proficiency: "100%" },
    { language: "Malay", proficiency: "100%" },
  ],
  qrURL: "https://manza-about.vercel.app/",
};
